import { Box } from "@mui/material";
import { baseURL } from "Enviroment";
import { LotImagesType } from "interfaces/LotImagesInterface";
import { useEffect } from "react";

interface LotOfferImageProps {
  lotOfferImage: LotImagesType;
}

export default function LotOfferSmallImage(props: LotOfferImageProps) {
  const url =
    props.lotOfferImage instanceof File ? URL.createObjectURL(props.lotOfferImage) :
    typeof props.lotOfferImage === "string"
      ? baseURL + props.lotOfferImage 
      : baseURL + props.lotOfferImage.thumbnail_url;
  useEffect(() => {
    return () => {
      if (props.lotOfferImage instanceof File) {
        URL.revokeObjectURL(url);
      }
    };
  }, [props.lotOfferImage, url]);
  return (
    <Box
      component="img"
      src={url}
      sx={{
        maxWidth: "100%",
        width: "100px",
        height: "70px",
      }}
    />
  );
}
